'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('dynamic-page-edit', {
      url: '/admin/dynpage/edit/:id',
      template: '<dynamic-page-edit></dynamic-page-edit>',
      authenticate: 'superadmin'
    });
}



// WEBPACK FOOTER //
// ./client/~ap/app/dynamic-pages/edit/dynamic-page-edit.routes.js